import { render, staticRenderFns } from "./expired.vue?vue&type=template&id=3394093a&scoped=true&"
import script from "./expired.vue?vue&type=script&lang=js&"
export * from "./expired.vue?vue&type=script&lang=js&"
import style0 from "./expired.vue?vue&type=style&index=0&id=3394093a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3394093a",
  null
  
)

export default component.exports